import {Content} from '@hconnect/uikit'
import {PageHeader} from '@hm/fundamental'
import {Paper} from '@material-ui/core'
import React from 'react'

import {useStyles} from './Whitelisting.styles'
import {EmailNotificationConfiguration} from './EmailConfiguration'
import {PushNotificationConfiguration} from './PushConfiguration'
import {SmsNotificationConfiguration} from './SmsConfiguration'

export const Whitelisting = () => {
  const classes = useStyles()
  return (
    <Content>
      <div className="[&_*]:!text-white">
        <PageHeader className="pl-0 pr-0 md:pl-0 md:pr-0">Whitelisting</PageHeader>
      </div>

      <Paper className={classes.paper}>
        <EmailNotificationConfiguration />
        <SmsNotificationConfiguration />
        <PushNotificationConfiguration />
      </Paper>
    </Content>
  )
}
